<template>
  <div
    class="reconciliation-panel"
    :class="{ 'dashboard-node--highlight': highlighted }"
  >
    <BaseFigures
      :items="items"
      :instance="instance"
      class="reconciliation-panel__figures"
    />

    <BaseDashboardTable
      :columns="columns"
      :rows="rows"
      :item-key="itemKey"
      :hide-default-footer="false"
      :server-items-length="serverItemsLength"
      :options="options"
      @detail="$emit('row-detail', $event)"
      @action="$emit('action', $event)"
      @update:options="$emit('update:options', { instance, options: $event })"
    />
  </div>
</template>

<script>
import BaseFigures from './BaseFigures.vue'
import BaseDashboardTable from './BaseDashboardTable.vue'
import DashboardHighlightOnRender from '../../mixins/DashboardHighlightOnRender'

export default {
  name: 'BaseReconciliationPanel',
  mixins: [DashboardHighlightOnRender],
  components: { BaseFigures, BaseDashboardTable },
  props: {
    items: {
      type: Array,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    rows: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: false,
      default: undefined
    },
    instance: {
      type: String,
      required: false,
      default: ''
    },
    serverItemsLength: {
      type: Number,
      required: false,
      default: -1
    },
    options: {
      type: Object,
      required: false,
      default: () => ({})
    }
  }
}
</script>

<style lang="scss">
.reconciliation-panel {
  &__figures {
    margin-bottom: 16px;
  }
}
</style>
